export const mkbz = {
    GD001: '/personalInformation',
    GD001_7: '/personalInformationFg',
    GD002: '/buy',
    GD002_1: '/buyFa',
    GD003: '/clothingSize',
    GD004: '/report',
    GD005: '/channel',
    GD005_1: '/szjdChannel',
    GD005_2: '/channelFb',
    GD006: '/chooseDormitory',
    GD006_1: '/scjtChooseDor',
    GD006_2: '/checkDormitory',
    GD006_3: '/cdzyjsxyChooseDor',
    GD006_5: '/allotDormitory',
    GD006_6: '/nxyszyxyChooseDor',
    GD007: '/major',
    GD007_1: '/majorFa',
    GD007_2:'/majorFb',
    GD007_3:'/majorFc',
    GD008: '/onlinePayment',
    GD009: '/print',
    GD010: '/sszychannel',
    GD011: '/sszywsjxf',
    GD012: '/sszyssfp',
    GD013: '/ssxzywsjssf',
    GD014: '/schoolUniform',
    GD021: '/education',
    GD023: '/examination',
    GD0081: 'nonTaxPay',
    // GD022:'/autobiography',
    GD001_1: '/info',
    GD008_1: '/onlinePaymentFxxy',
    GD008_3: '/wxChatPay',
    GD001_2: '/pInfo',
    GD004_1:'/reportGdnhgs',
    GD004_3:'/reportCzxy',
    GD001_5:'/infoGdnhgs',
    GD001_6:'/infoHncs',
    GD004_2:'/reportHncs',
    GD005_4:'/channelZtxy',
    GD005_5:'/channelTlxy',
    GD005_6:'/channelCzxy',
    GD027_1: '/choosePhoneNum',
    GD001_4: '/newInfo',
    GD001_3: '/szjdInfo',
    GD031:'/mentalHealthSurvey',
    GD032:'/applyDorm',
    GD033:'/viewStudentId',
    GD005_8:'/ahGsLsTd',
    GD034:'/antiepidemic',
    GD004_4:'/reportwhrj',
    GD006_4:'/whrjChooseDor',
    GD024_1:'/medicalInsurance',
    GD005_11:'/lstdghlb'
}


// WEBPACK FOOTER //
// ./app/pages/Assembly/siderMenu/menuObj.js